import gql from 'graphql-tag'
import graphql from 'utils/graphql'
import {
    UpdateBoothMutation,
    UpdateBoothMutationVariables,
    CreateBoothMutation,
    CreateBoothMutationVariables,
    DeleteBoothMutation,
    DeleteBoothMutationVariables
} from 'generated/graphql'

const updateBoothMutation = gql`
    mutation updateBooth($id: Int!, $data: UpdateBooth!) {
        updateBooth(id: $id, data: $data) {
            id
            staffMembers {
                id
                email
                hasLoggedOn
            }
        }
    }
`
export const updateBooth = graphql
    .createQuery<UpdateBoothMutation, UpdateBoothMutationVariables>(updateBoothMutation)

export const updateBoothOrder = (id, order) => {
    const query = graphql.createQuery<UpdateBoothMutation, UpdateBoothMutationVariables>(updateBoothMutation)
    return query({ id, data: { order } })
}

const createBoothMutation = gql`
    mutation createBooth($eventId: EventID!, $data: CreateBooth!) {
        createBooth(event: $eventId, data: $data) {
            id
        }
    }
`

export const createBooth = graphql
    .createQuery<CreateBoothMutation, CreateBoothMutationVariables>(createBoothMutation)

const deleteBoothMutation = gql`
    mutation deleteBooth($id: ID!) {
        deleteSpace(data: {id: $id, type: booth})
    }
`

export const deleteBooth = graphql
    .createQuery<DeleteBoothMutation, DeleteBoothMutationVariables>(deleteBoothMutation)

export const inviteAdmin = (id, email) => {
    const mutation = graphql
        .createQuery<UpdateBoothMutation, UpdateBoothMutationVariables>(updateBoothMutation)
    return mutation({ id, data: { inviteStaff: email } })
}

export const removeAdmin = (id, email) => {
    const mutation = graphql
        .createQuery<UpdateBoothMutation, UpdateBoothMutationVariables>(updateBoothMutation)
    return mutation({ id, data: { removeStaff: email } })
}
